<script lang="ts">
  import type { ApiField } from '../../data-tables-api';
  import countries from '../../countries.json';

  let {
    field,
    value,
    onChange,
    error,
    disabled = false,
  }: {
    field: ApiField;
    value: unknown;
    onChange: (v: unknown) => void;
    error?: string | null;
    disabled?: boolean;
  } = $props();

  const code = $derived(value != null ? String(value).toUpperCase() : '');
</script>

<select
  value={code}
  onchange={(e) => onChange((e.target as HTMLSelectElement).value || null)}
  required={field.required}
  {disabled}
  class="w-full rounded-md border bg-white px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[var(--color-pu)] {error ? 'border-red-400' : 'border-[var(--color-border-3)]'}"
>
  <option value="">{field.required ? '— оберіть країну —' : '— не задано —'}</option>
  {#each countries as c (c.code)}
    <option value={c.code}>{c.flag} {c.name}</option>
  {/each}
</select>
{#if error}
  <div class="mt-1 text-[11px] text-red-600">{error}</div>
{/if}
